export default __webpack_public_path__ + "static/media/Halloween3.de76b3b8.mp3";